import { ModalId } from '../../../../../enums/modalId'

export const getBlockCreateInvoiceActionModalId = (scopeId?: string): string =>
  scopeId ? `${scopeId}-${ModalId.BlockCreateInvoiceActionModal}` : ModalId.BlockCreateInvoiceActionModal
